import {
  LOCALE_ID,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { registerLocaleData, CurrencyPipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import localeDe from '@angular/common/locales/de';
import localeHr from '@angular/common/locales/hr';
import localeEn from '@angular/common/locales/en';
import localeSe from '@angular/common/locales/se';
import localePt from '@angular/common/locales/pt';
import localeFr from '@angular/common/locales/fr';
import localeSv from '@angular/common/locales/sv';
import localeEs from '@angular/common/locales/es';
import { UserInfo } from '@longnecktech/splash-commons-fe';

import { TranslationService } from '@services/translation.service';
import { SessionService } from '@services/session.service';
import { getTokenParams } from '@shared/utils/get-token-params';
import { AuthInterceptor } from '@interceptors/auth.interceptor';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

registerLocaleData(localeDe, 'de');
registerLocaleData(localeHr, 'hr');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeSe, 'se');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeSv, 'sv');
registerLocaleData(localeEs, 'es');

type WindowWithUser = Window & typeof globalThis & { user: UserInfo };

export function localeFactory() {
  const lang = (window as WindowWithUser).user.language || 'en';
  return TranslationService.supportedLanguages.includes(lang) ? lang : 'en';
}

@NgModule({
  declarations: [AppComponent],
  imports: [AppRoutingModule, RouterModule, BrowserModule],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    CurrencyPipe,
    provideAppInitializer(() => {
      const sessionService = inject(SessionService);
      const params = getTokenParams();
      sessionService.thirdPartyToken = params.token;
      sessionService.instance = params.instance;
      sessionService.gameUuid = params.gameUuid;
      sessionService.setUser((window as WindowWithUser).user);
    }),
    {
      provide: LOCALE_ID,
      useFactory: localeFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
